import Pagination from "react-bootstrap/Pagination";
import Form from "react-bootstrap/Form";
import {useEffect, useState} from "react";


const PaginationBar = ({items, setPageItems, uncheckAll}) => {
    const [itemsPerPage, setItemsPerPage] = useState(25);
    const [currentPage, setCurrentPage] = useState(1);
    const totalPages = Math.ceil(items.length / itemsPerPage);
    let middlePage = Math.ceil(totalPages / 2);
    if (currentPage !== 1 && currentPage !== 2 && currentPage !== (totalPages - 1) && currentPage !== totalPages)
        middlePage = currentPage;

    function handlePageChange(pageNumber) {
        setCurrentPage(pageNumber);
        window.scrollTo({
            top: 0,
            behavior: "smooth"
        });
        uncheckAll && uncheckAll();
    }

    function onChangeNumPages(event) {
        setItemsPerPage(event.target.value);
        handlePageChange(1);
    }

    useEffect(() => {
        const pageItems = items.slice((currentPage - 1) * itemsPerPage, currentPage * itemsPerPage);
        setPageItems(pageItems);
    }, [items, currentPage, itemsPerPage, setPageItems]);
    if(items.length === 0){
        return <></>;
    }

    return (
        <>
            <Pagination>
                <Pagination.First onClick={() => handlePageChange(1)} disabled={currentPage === 1}/>
                <Pagination.Prev onClick={() => handlePageChange(currentPage - 1)} disabled={currentPage === 1}/>
                {totalPages < 7 ?
                    [...Array(totalPages).keys()].map(number => (
                        <Pagination.Item
                            key={number + 1}
                            active={number + 1 === currentPage}
                            onClick={() => handlePageChange(number + 1)}
                        >
                            {number + 1}
                        </Pagination.Item>
                    )) : <>
                        <Pagination.Item
                            key={1}
                            active={1 === currentPage}
                            onClick={() => handlePageChange(1)}
                        >
                            1
                        </Pagination.Item>
                        <Pagination.Item
                            key={2}
                            active={2 === currentPage}
                            onClick={() => handlePageChange(2)}
                        >
                            2
                        </Pagination.Item>

                        <Pagination.Ellipsis/>

                        <Pagination.Item
                            key={middlePage}
                            active={middlePage === currentPage}
                            onClick={() => handlePageChange(middlePage)}
                        >
                            {middlePage}
                        </Pagination.Item>

                        <Pagination.Ellipsis/>

                        <Pagination.Item
                            key={totalPages - 1}
                            active={(totalPages - 1) === currentPage}
                            onClick={() => handlePageChange(totalPages - 1)}
                        >
                            {totalPages - 1}
                        </Pagination.Item>
                        <Pagination.Item
                            key={totalPages}
                            active={totalPages === currentPage}
                            onClick={() => handlePageChange(totalPages)}
                        >
                            {totalPages}
                        </Pagination.Item>
                    </>

                }
                <Pagination.Next onClick={() => handlePageChange(currentPage + 1)}
                                 disabled={currentPage === totalPages}/>
                <Pagination.Last onClick={() => handlePageChange(totalPages)}
                                 disabled={currentPage === totalPages}/>

                <Form.Select className="ms-2"
                             name="elementos por pag"
                             onChange={onChangeNumPages}
                             defaultValue={25}
                >
                    <option value={10}>10</option>
                    <option value={25}>25</option>
                    <option value={50}>50</option>
                    <option value={100}>100</option>
                    <option value={500}>500</option>
                    <option value={1000}>1000</option>
                </Form.Select>
            </Pagination>


        </>
    )

}

export default PaginationBar